"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autobind = void 0;
/*
 * Code pulled from https://github.com/andreypopp/autobind-decorator/blob/master/src/index.js
 *
 * A decorator that automatically bind a class method to an instance of that class.
 */
var autobind = function (target, key, descriptor) {
  var fn = descriptor.value;
  if (typeof fn !== 'function') {
    throw new Error("@autobind decorator can only be applied to methods not: ".concat(typeof fn));
  }
  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.
  var definingProperty = false;
  return {
    configurable: true,
    get: function () {
      if (definingProperty || this === target.prototype || Object.prototype.hasOwnProperty.call(this, key) || typeof fn !== 'function') {
        return fn;
      }
      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get: function () {
          return boundFn;
        },
        set: function (value) {
          fn = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set: function (value) {
      fn = value;
    }
  };
};
exports.autobind = autobind;